/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum NotificationTypes {
  UserCredit = 0,
  UserExpiration = 1,
  ChangePassword = 2,
  OrganizationExpiration = 3,
  PrivateNumberExpiration = 4,
  BlockedUsers = 5,
  NewUser = 6,
  SendQueueError = 7,
  CreateWhiteMessageRequest = 8,
  SocialNetworkMessage = 9,
  ConfirmationMessage = 10,
  SendSmsAlert = 11,
  CreateSmartSmsRequestAlert = 12,
  Payment = 13,
  CreateApiToken = 14,
  DeleteOrDisablePrivateNumber = 15,
  OrganizationCredit = 16,
  RFMStatistics = 17
}
